//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { navigateToChat } from '@/views/consultants/mixin/card'
import PublicService from '@/service/public'
import SubscribeTip from '../_components/_subscribe_tip'

export default {
    components: {
        SubscribeTip
    },
    props: {
        building_id: [Number, String],
        show_consultant_footer: Boolean,
        page: String,
        favourite: Boolean,
        add_group_url: String,
        current_consultant: Object,
        building: Object
    },
    computed:{
        force_phone_auth(){
            return this.building && this.building.activities && this.building.activities.indexOf('授权手机号') > -1
        }
    },
    created () {
    },
    methods: {
        goCard (e) {
            const { id } = e.target.dataset
            wx.navigateTo({
                url: `/consultants/card/main?id=${id}`
            })
        },
        goConsultantByUser (id) {
            if (id) {
                navigateToChat(id)
            } else {
                wx.navigateTo({
                    url: `/consultants/filter/main?id=${this.building_id}`
                })
            }
            this.$sendCtmEvtLog(`${this.page}-底部联系置业顾问点击`)
        },
        goCall (id) {
            this.$showCallModal(() => {
                this.getPhoneCall(id)
            }, `${this.page}-底部免费电话咨询点击`)
        },
        getPhoneCall (consultant_id) {
            const params = {
                sceneable_id: consultant_id || this.building_id,
                sceneable_type: consultant_id ? 'Fc::Consultant' : 'Fc::Building'
            }
            PublicService.getPhonePosition(params).then(({ phone }) => {
                if (!phone) {
                    wx.showToast({
                        icon: 'none',
                        title: '暂无该项目电话'
                    })
                    return
                }
                wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        }
    }
}
